import { ValueGetterParams } from 'ag-grid-enterprise';
import { DocumentReader } from 'src/app/modules/core/store/models';

export const enumValueGetter = (params: ValueGetterParams) => {
  const field = params.colDef.cellRendererParams.schemaField;
  const enumerationService = params.colDef.cellRendererParams.enumerationService;

  const reader = new DocumentReader(params.data);
  const selectedItems = reader.getFieldValue(field.systemName);

  let value = '';
  if (!!selectedItems) {
    if (!!enumerationService) {
      enumerationService
        .getEnumerationValues(field)
        .pipe()
        .subscribe(enumerationValues => {
          selectedItems.map(val => {
            const selectedEnumerationItem = enumerationValues?.find(pv => pv.value === val);
            if (!!selectedEnumerationItem) {
              value += value.length > 0 ? `, ${selectedEnumerationItem.value}` : selectedEnumerationItem.value;
            }
          });
        });
    } else {
      selectedItems.map(val => {
        const selectedEnumerationItem = field.enumerationValues?.find(pv => pv.value === val);
        if (!!selectedEnumerationItem) {
          value += value.length > 0 ? `, ${selectedEnumerationItem.value}` : selectedEnumerationItem.value;
        }
      });
    }
  }

  return value;
};
